import { Dispatch } from "redux";
import { BinInfo, BinTypeList, CleanerList, ContainerList, ContractList, DepotList, DistrictList, EnquiryType, RecylcableList, ZoneList } from "./state";
import { ChangeBinListAction, InitBinListAction, InitBinTypeListAction, InitCleanerListAction, InitContractListAction, InitDistrictListAction, StaticInfoAction, changeFilteredZoneListAction, initContainerListAction, initDepotListAction, initReyclableListAction, initStaticAction, initZoneListAction,  } from "./action";

export function initStaticThunk (enquiryType:EnquiryType[],districtList:DistrictList[],binList:BinInfo[]){
    return (dispatch: Dispatch<StaticInfoAction>)=>{
        dispatch(initStaticAction(enquiryType,districtList,binList));  
    }
}

export function ChangebinListThunk(district_id:string,binList:BinInfo[]){

    const newBinList = binList.filter((list=>list.district_id===parseInt(district_id)))
    return (dispatch: Dispatch<StaticInfoAction>)=>{
        dispatch(ChangeBinListAction(newBinList));  
    }
}

export function initBinList(binList:BinInfo[]){
    return (dispatch: Dispatch<StaticInfoAction>)=>{
        dispatch(InitBinListAction(binList));  
   

    }
}

export function initCleanerListThunk(cleanerList:CleanerList[]){
    return (dispatch: Dispatch<StaticInfoAction>)=>{
        dispatch(InitCleanerListAction(cleanerList));  
    }
}

export function initContractListThunk(contractList:ContractList[]){
    return (dispatch: Dispatch<StaticInfoAction>)=>{
        dispatch(InitContractListAction(contractList));  
    }
}

export function initDistrictListThunk(districtList:DistrictList[]){
    return (dispatch: Dispatch<StaticInfoAction>)=>{
        dispatch(InitDistrictListAction(districtList));  
    }
}

export function initBinTypeListThunk(binlist:BinTypeList[]){
    return (dispatch: Dispatch<StaticInfoAction>) => {
        dispatch(InitBinTypeListAction(binlist));
    };

}

export function initContainerListThunk(containerList:ContainerList[]){
    return (dispatch: Dispatch<StaticInfoAction>) => {
        dispatch(initContainerListAction(containerList));
    };
}

export function initReyclableListThunk(recylcableList:RecylcableList[]){
    return (dispatch: Dispatch<StaticInfoAction>) => {
        dispatch(initReyclableListAction(recylcableList));
    };
}

export function initDepotListThunk(depotList:DepotList[]){
    return (dispatch: Dispatch<StaticInfoAction>) => {
        dispatch(initDepotListAction(depotList));
    };
}
export function initZoneListThunk(zoneList:ZoneList[]){
    return (dispatch: Dispatch<StaticInfoAction>) => {
        dispatch(initZoneListAction(zoneList));
    };
}


export function changeFilteredZoneListThunk(filteredZoneList:ZoneList[]){
    return (dispatch: Dispatch<StaticInfoAction>) => {
        dispatch(changeFilteredZoneListAction(filteredZoneList));
    };
}